// 产品数据配置
export const productsData = [
  {
    id: "dushecam",
    name: "毒舌相机",
    description: "AI内容创作助手，解决你的表达困境",
    logo: "./images/products/dushecam/dushe_logo.webp",
    features: [
      "拍照即可生成多种风格文案",
      "智能匹配场景情感表达",
      "热门文案一键生成"
    ],
    images: [
      "./images/products/dushecam/dushe_show_01.webp",
      "./images/products/dushecam/dushe_show_02.webp",
      "./images/products/dushecam/dushe_show_03.webp"
    ],
    url: "https://www.gravityapps.cn/dushecam"
  },
  {
    id: "bairemovebg",
    name: "小白抠图",
    description: "零基础操作，专业级抠图体验",
    logo: "./images/products/bairemovebg/koutu_logo.webp",
    features: [
      "智能识别主体",
      "支持批量处理",
      "自动生成透明背景"
    ],
    images: [
      "./images/products/bairemovebg/koutu_show_01.webp",
      "./images/products/bairemovebg/koutu_show_02.webp",
      "./images/products/bairemovebg/koutu_show_03.webp"
    ],
    url: "https://www.gravityapps.cn/bairemovebg"
  },
  {
    id: "portrait",
    name: "轻氧写真",
    description: "AI打造个性写真集",
    logo: "./images/products/portrait/xz_logo.webp",
    features: [
      "多风格模板",
      "即拍即出大片",
      "智能美颜优化"
    ],
    images: [
      "./images/products/portrait/xz_show_01.webp",
      "./images/products/portrait/xz_show_02.webp",
      "./images/products/portrait/xz_show_03.webp"
    ],
    url: "https://www.gravityapps.cn/portrait"
  },
  {
    id: "comicfilter",
    name: "漫画滤镜",
    description: "一键将照片转换为精美漫画风格",
    logo: "./images/products/comicfilter/mh-logo.png",
    features: [
      "AI智能转换算法",
      "多种漫画风格选择",
      "高清画质输出"
    ],
    images: [
      "./images/products/comicfilter/mh01.jpg",
      "./images/products/comicfilter/mh02.jpg",
      "./images/products/comicfilter/mh03.jpg"
    ],
    url: "https://www.gravityapps.cn/comicfilter"
  },
  {
    id: "tukeedit",
    name: "涂可修图",
    description: "智能修图工具，让每张照片都完美",
    logo: "./images/products/tukeedit/tk-logo.png",
    features: [
      "自动美颜功能",
      "专业级调色滤镜",
      "一键去除瑕疵"
    ],
    images: [
      "./images/products/tukeedit/tk01.png",
      "./images/products/tukeedit/tk02.png",
      "./images/products/tukeedit/tk03.png"
    ],
    url: "https://www.gravityapps.cn/tuke"
  },
  {
    id: "moodnote",
    name: "MOKA日记",
    description: "三秒写下此刻，未来都有答案",
    logo: "./images/products/moodnote/moka_app_logo.png",
    features: [
      "表情记录快速完成",
      "心情日历直观展示",
      "时间轴串联瞬间"
    ],
    images: [
      "./images/products/moodnote/01.webp",
      "./images/products/moodnote/02.webp",
      "./images/products/moodnote/03.webp"
    ],
    url: "https://www.gravityapps.cn/moodnote"
  }
];

// 根据ID获取产品数据
export const getProductById = (id) => {
  return productsData.find(product => product.id === id);
};
